/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { Header, UsersListComp } from '../components';

import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useSMArchived } from '@pages/ArchivedPolicy/machines';
import { ArchivedPageService } from '@pages/ArchivedPolicy/services';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';

const getSrv = () => {
  return vappContainer.get<ArchivedPageService>(ArchivedPageService.name);
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setRefreshPagination] = useState(new Date());
  const srv = getSrv();

  useEffect(() => {
    //srv?.resetCriteria();
  }, []);

  const { archivedPageSend, archivedPageState } = useSMArchived({});

  console.log('render page', archivedPageState?.event?.data?.value);

  const onRefresh = () => {
    archivedPageSend('TRIGGER_REFRESH', {});
    setRefreshPagination(new Date());
  };

  const onClearFilter = () => {
    //srv?.resetCriteria();
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    archivedPageSend('TRIGGER_REFRESH', {});
  };

  const _renderNotification = () => {
    return null;
  };

  const onPaginationChange = (event: any) => {
    archivedPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!archivedPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(archivedPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={archivedPageState?.event?.data?.value?.ultUsers?.length}
        />
      );
    }
  };

  const onApplyFilter = (data: any) => {
    console.log('apply clicked', data);
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    archivedPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const _renderArchived = () => {
    if (archivedPageState?.matches('GET_ARCHIVED_POLICY')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingArchivedSync()?.loading
            ?.retrieveCredentials || {})}
        />
      );
    }

    if (archivedPageState?.matches('RENDER_ARCHIVED_POLICY')) {
      return (
        <>
          {archivedPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(srv?.agent?.getLoadingArchivedSync()?.loading
                ?.credentialListEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(archivedPageState?.event?.data?.value?.ArchivedList || {})}
              onViewDetailClick={props?.onViewDetailClick}
              onRowClick={props?.onViewDetailClick}
            />
          )}
        </>
      );
    }
    return null;
  };

  const _renderErrorModals = () => {
    if (archivedPageState?.matches('RENDER_ARCHIVED_POLICY_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorArchivedSync()?.error?.formSubmit || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (srv?.agent?.getHeaderArchivedSync()?.header) {
      return (
        <>
          <Header
            {...(srv?.agent?.getHeaderArchivedSync()?.header || {})}
            onRefreshClick={onRefresh}
          />
          <SearchFilter
            {...(srv?.agent?.getSettingsArchivedSync()?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderArchived()}
        {_renderPagination()}
        {_renderErrorModals()}
        {_renderNotification()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
